export default __webpack_public_path__ + "static/media/padlock_red_icone.841aa165.svg";